export default "__VITE_ASSET__B0WP6Sxf__"